export default "__VITE_ASSET__BiZpUE$a__"